type ServiceWorkerHost = {
  serviceWorker?: Pick<ServiceWorkerContainer, 'getRegistration'>;
};

/**
 * Look up the current service worker registration without throwing.
 * Chrome Mobile rejects getRegistration() with NotSupportedError when the
 * user (or a restricted document) denies Service Worker permission.
 */
const getServiceWorkerRegistration = async (
  host: ServiceWorkerHost = navigator,
): Promise<ServiceWorkerRegistration | null> => {
  try {
    if (host == null || host.serviceWorker == null) {
      return null;
    }

    const registration = await host.serviceWorker.getRegistration();
    return registration ?? null;
  } catch {
    return null;
  }
};

export default getServiceWorkerRegistration;
